import React, { FC } from 'react'
import { Dialog } from '../../ui/Dialog/Dialog'
import { SendFill } from '../../../assets/icons'
import { Typography } from '../../ui/Typography/Typography'
// import { L_HTML } from '../../providers/Lokalise'
import { Button } from '../../ui/Button/Button'
import { L } from '../../providers/Lokalise'

export interface ImitatorNoAccessWarningProps {
    show?: boolean
    onClose?: () => void
}

const ImitatorNoAccessWarning: FC<ImitatorNoAccessWarningProps> = ({
    show,
    onClose,
}) => {
    if (!show) return null

    return (
        <Dialog
            trigger={null}
            defaultOpen
            hideClose
            icon={<SendFill width="46px" />}
        >
            <Typography
                style={{ marginBottom: '30px' }}
                size="L"
                align="center"
            >
                {L('imitator_restricted_access_title')}
            </Typography>
            <Typography
                tag="p"
                size="S"
                style={{ marginBottom: '30px' }}
                align="center"
            >
                {L('imitator_restricted_access_text')}
            </Typography>
            <Button size="xlarge" onClick={() => onClose && onClose()}>
                {L('imitator_restricted_access_button')}
            </Button>
        </Dialog>
    )
}

export { ImitatorNoAccessWarning }
